import { call, put, takeLatest } from 'redux-saga/effects';
import { setTable } from './actions';
import { getTable } from './api';
import { FETCH_TABLES_START } from './constants';

function* asyncFetchTable(param: any) {
	const response: string = yield call(getTable);
	yield put(setTable(response));
}

export function* sagaWatcher() {
	yield takeLatest(FETCH_TABLES_START, asyncFetchTable);
}

const gens = [sagaWatcher()];
export default gens;
